<template>
  <div>
    <div class="banner_container">
      <div class="banner_title">关于我们</div>
      <img
        src="~@/assets/images/listitem/pic-banner@2x.png"
        alt=""
        style="width: 100%; height: 100%"
      />
    </div>
    <div class="container_wrap organization_container">
      <el-tabs
        v-model="activeName"
        type="card"
        @tab-click="handleClick"
        class="eltab"
      >
        <el-tab-pane
          :label="item.name"
          :name="item.name"
          v-for="(item, index) in firstSecretaryTitleList"
          :key="index"
        >
          <div
            class="tabpane_container html-data"
            v-html="item.content"
            v-if="item.content"
          ></div>
          <div class="secretary_title" v-else>
            <div
              class="secretary_title_item"
              v-for="(item, index) in secretaryTitleList"
              :key="index"
              :class="item.class"
              @click="secretarySortSelect(item)"
            >
              {{ item.name }}
            </div>
          </div>
          <div class="secretary_list" v-if="!item.content">
            <div
              class="memberlistitem"
              v-for="(item, index) in MemberList"
              :key="index"
            >
              <member-list-item :memberlistitem="item"></member-list-item>
            </div>
          </div>
        </el-tab-pane>

        <!-- <el-tab-pane label="横店影视城联系地图" name="横店影视城联系地图">
          <div class="tabpane_container" v-html="conmap"></div>
        </el-tab-pane>
        <el-tab-pane label="横店影视城交通路线" name="横店影视城交通路线">
          <div class="tabpane_container" v-html="driverLine"></div>
        </el-tab-pane>
        <el-tab-pane label="EAE秘书处" name="EAE秘书处">
          <div class="secretary_title">
            <div
              class="secretary_title_item"
              v-for="(item, index) in secretaryTitleList"
              :key="index"
              :class="item.class"
              @click="secretarySortSelect(item)"
            >
              {{ item.name }}
            </div>
          </div>
          <div class="secretary_list">
            <div
              class="memberlistitem"
              v-for="(item, index) in MemberList"
              :key="index"
            >
              <member-list-item :memberlistitem="item"></member-list-item>
            </div>
          </div>
        </el-tab-pane> -->
      </el-tabs>
    </div>
    <DeBounce
      :fetch-fun="DeBounceFetchData"
      :pagefetchflag="pagefetchflag"
    ></DeBounce>
  </div>
</template>
<script>
import DeBounce from "@/components/DeBounce";
import MemberListItem from "@/components/listItem/MemberListItem";
export default {
  name: "CmsCate",
  data() {
    return {
      activeName: "",
      firstSecretaryTitleList: [], //第一级 tab切换
      secretaryTitleList: [
        {
          name: "全部",
          class: "secretary_title_item_active",
          cate_id: 94,
        },
        {
          name: "客服管理部",
          class: "",
          cate_id: 107,
        },
        {
          name: "竞赛活动部",
          class: "",
          cate_id: 108,
        },
        {
          name: "国际交流部",
          class: "",
          cate_id: 109,
        },
        {
          name: "各省管理中心",
          class: "",
          cate_id: 110,
        },
        {
          name: "战略推广部",
          class: "",
          cate_id: 111,
        },
      ],
      MemberList: [], //秘书处列表数据
      // conmap: "", //联系地图内容
      // driverLine: "", //路线内容
      secretaryParams: {
        p: 1,
        step: 20,
        cate_id: "",
      },
      pagefetchflag: true,
    };
  },
  mounted() {
    this.getFirstTab();
    this.getThreeTab();
    // this.judgePlaceNow();
    // console.log(this.$route.query.id)
    // this.getconmap();
    // this.getDiveLine();
    // var tempObj = {};
    // var that = this;
    // this.secretaryTitleList.find(function (item) {
    //   if (item.cate_id == parseInt(that.$route.query.idX)) {
    //     tempObj = item;
    //   }
    // });
    // this.secretarySortSelect(tempObj);
  },
  computed: {
    idinsecretaryFlag() {
      if (this.$route.name == "Cate") {
        var secretaryFlag = false;
        this.secretaryTitleList.some((item) => {
          if (item.cate_id == this.$route.query.id) {
            secretaryFlag = true;
          }
        });
        if (secretaryFlag) {
          return true;
        } else {
          return false;
        }
      } else {
        return false;
      }
    },
  },
  methods: {
    DeBounceFetchData() {
      if (this.$route.query.id != 96 && this.$route.query.id != 95) {
        this.getSecretaryList(this.secretaryParams.cate_id);
      }
    },
    //获取二级tab
    getFirstTab() {
      // http://api.eaechina.net/api/cms/catelist?parent_id=93
      const that = this;
      that.$api.get(
        "/api/cms/catelist",
        {
          parent_id: 93, //93 二级tab的父级
          status: 1,
        },
        (res) => {
          that.firstSecretaryTitleList = res.data;
          // this.activeName = this.firstSecretaryTitleList[0].name;
          this.judgePlaceNow();
        },
        (r) => {
          that.$message.error(r.msg);
        }
      );
    },
    //获取三级tab
    getThreeTab() {
      // http://api.eaechina.net/api/cms/catelist?parent_id=93
      const that = this;
      that.$api.get(
        "/api/cms/catelist",
        {
          parent_id: 94, //94 三级tab的父级
        },
        (res) => {
          that.secretaryTitleList = res.data;
          var tempObj = {
            name: "全部",
            class: "secretary_title_item_active",
            cate_id: 94,
          };
          for (var i = 0; i < that.secretaryTitleList.length; i++) {
            that.secretaryTitleList[i]["cate_id"] =
              that.secretaryTitleList[i].id;
            that.secretaryTitleList[i]["class"] = "";
          }
          that.secretaryTitleList.unshift(tempObj);
          // console.log("that.secretaryTitleList", that.secretaryTitleList);
        },
        (r) => {
          that.$message.error(r.msg);
        }
      );
    },
    // 在secretaryTitleList中查找点击元素所在位置
    findInSecretaryfun(cate_id) {
      var result = {};
      this.secretaryTitleList.find(function (item) {
        if (item.cate_id == cate_id) {
          result = item;
        }
      });
      return result;
    },
    //判断当前所处tab位置-》根据this.$route.query.id
    judgePlaceNow() {
      if (this.$route.name == "Cate") {
        // var this.firstSecretaryTitleList.filter((item)=>{})
        this.firstSecretaryTitleList.some((item) => {
          if (item.id == this.$route.query.id) {
            this.activeName = item.name;
          }
        });
        if (this.idinsecretaryFlag) {
          this.activeName = "EAE秘书处";
          var that = this;
          setTimeout(function () {
            var val = that.findInSecretaryfun(that.$route.query.id);
            that.secretarySortSelect(val); //94秘书处 全部
          }, 300);
        }
      }
      // if (this.$route.query.idX == 96) {
      //   this.activeName = "横店影视城联系地图";
      // } else if (this.$route.query.idX == 95) {
      //   this.activeName = "横店影视城交通路线";
      // } else if (this.idinsecretaryFlag) {
      //   this.activeName = "EAE秘书处";
      //   var that = this;
      //   setTimeout(function () {
      //     var val = that.findInSecretaryfun(that.$route.query.idX);
      //     that.secretarySortSelect(val); //94秘书处 全部
      //   }, 300);
      // }
    },
    // 判断数据是否存在于秘书处的列表中
    // judgeExist() {
    //   var that = this;
    //   var boolres = false;
    //   this.secretaryTitleList.find(function (item) {
    //     if (item.cate_id == that.$route.query.idX) {
    //       boolres = true;
    //     }
    //   });
    //   return boolres;
    // },
    //tab点击事件
    handleClick(val) {
      if (this.activeName == "EAE秘书处") {
        this.$router.push({ path: "/cate", query: { id: 94, } });
        var val = this.findInSecretaryfun(this.$route.query.id);
        this.secretarySortSelect(this.secretaryTitleList[0]); //94秘书处 全部
      } else {
        this.firstSecretaryTitleList.some((item) => {
          if (item.name == this.activeName) {
            this.$router.push({
              path: "/cate",
              query: { id: item.id },
            });
          }
        });
      }
      // if (this.activeName == "横店影视城联系地图") {
      //   this.$router.push({ path: "/cate", query: { id: 96, idX: 96 } });
      // } else if (this.activeName == "横店影视城交通路线") {
      //   this.$router.push({ path: "/cate", query: { id: 95, idX: 95 } });
      // } else if (this.activeName == "EAE秘书处") {
      //   this.$router.push({ path: "/cate", query: { id: 94, idX: 94 } });
      //   var val = this.findInSecretaryfun(this.$route.query.id);
      //   this.secretarySortSelect(this.secretaryTitleList[0]); //94秘书处 全部
      // }
    },
    //秘书筛选 点击事件
    secretarySortSelect(val) {
      for (let i = 0; i < this.secretaryTitleList.length; i++) {
        if (this.secretaryTitleList[i].class == "secretary_title_item_active") {
          this.secretaryTitleList[i].class = "";
        }
      }
      let valindex = this.secretaryTitleList.indexOf(val);
      this.secretaryTitleList[valindex].class = "secretary_title_item_active";
      this.$router.push({
        path: "/cate",
        query: {
          id: this.secretaryTitleList[valindex].cate_id,
        },
      });
      this.getSecretaryList(this.secretaryTitleList[valindex].cate_id);
    },
    //获取秘书列表secretary;
    getSecretaryList(cate_id) {
      var that = this;
      if (this.secretaryParams.cate_id != cate_id) {
        this.secretaryParams.p = 1;
        this.pagefetchflag = true;
      }
      this.secretaryParams.cate_id = cate_id;
      that.$api.get(
        "/api/cms/helpList",
        this.secretaryParams,
        (res) => {
          if (this.secretaryParams.p == 1) {
            that.MemberList = res.data.list;
          } else {
            if (
              res.data.list &&
              res.data.list.length < this.secretaryParams.step
            ) {
              this.pagefetchflag = false;
              // this.$message.success("已加载全部！");
            }
            that.MemberList = that.MemberList.concat(res.data.list);
          }
          if (this.pagefetchflag) {
            this.secretaryParams.p += 1;
          }
        },
        (r) => {
          that.$message.error(r.msg);
        }
      );
    },
    //获取联系地图
    // getconmap() {
    //   const that = this;
    //   that.$api.get(
    //     "/api/cms/helpList",
    //     {
    //       cate_id: 96,
    //     },
    //     (res) => {
    //       that.conmap = res.data.list[0].content;
    //     },
    //     (r) => {
    //       that.$message.error(r.msg);
    //     }
    //   );
    // },
    //获取交通路线
    // getDiveLine() {
    //   const that = this;
    //   that.$api.get(
    //     "/api/cms/helpList",
    //     {
    //       cate_id: 95,
    //     },
    //     (res) => {
    //       that.driverLine = res.data.list[0].content;
    //     },
    //     (r) => {
    //       that.$message.error(r.msg);
    //     }
    //   );
    // },
  },
  components: {
    MemberListItem,
    DeBounce,
  },
};
</script>
<style lang="scss">
.organization_container {
  .tabpane_container {
    p {
      font-size: 14px !important;
      line-height: 20px;
    }
  }
}
</style>
<style scoped lang="scss">
// @font-face {
//   /* font-properties */
//   font-family: EuclidFlex-Bold;
//   src: url("~@/assets/font/EuclidFlex-Bold.ttf");
// }
.banner_container {
  max-height: 318px;
  width: 100%;
  background: #f4faff;
  position: relative;
  .banner_title {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 1240px;
    font-size: 48px;
    font-family: "Euclid Flex Bold", Arial, "PingFang SC", Verdana,
      "\5FAE\8F6F\96C5\9ED1";
    font-weight: 400;
    color: #ffffff;
  }
}
.container_wrap {
  background: #f4faff;
}
/deep/.eltab
  >>> .el-tabs__header
  >>> .el-tabs__nav-wrap
  >>> .el-tabs__nav-scroll
  >>> .el-tabs__nav {
  border: none;
  display: flex;
  align-items: flex-end;
}
/deep/.eltab
  >>> .el-tabs__header
  >>> .el-tabs__nav-wrap
  >>> .el-tabs__nav-scroll
  >>> .el-tabs__nav
  >>> .el-tabs__item {
  box-shadow: none;
  width: 276px;
  height: 89px;
  background: #ff8d3a;
  box-shadow: 0px 0px 16px 2px rgba(43, 81, 149, 0.3);
  border-radius: 32px 32px 0px 0px;
  font-size: 24px;
  font-family: "Euclid Flex Bold", Arial, "PingFang SC", Verdana,
    "\5FAE\8F6F\96C5\9ED1";
  font-weight: 500;
  color: #ffffff;
  line-height: 89px;
  text-align: center;
  margin-right: 25px;
  border-left: none;
}
/deep/.eltab
  >>> .el-tabs__header
  >>> .el-tabs__nav-wrap
  >>> .el-tabs__nav-scroll
  >>> .el-tabs__nav
  >>> .is-active {
  height: 107px;
  line-height: 127px;
  background: #ffffff;
  color: #333333;
  box-shadow: 0px 0px 16px 2px rgba(0, 0, 0, 0.1);
}
/deep/.eltab >>> .el-tabs__content {
  width: 1240px;
  min-height: 690px;
  background: #ffffff;
  box-shadow: 0px 10px 10px 0px rgba(0, 0, 0, 0.1);
  border-radius: 0px 0px 48px 48px;
}
/deep/.eltab >>> .el-tabs__header {
  margin: 0;
  border: none;
}

/deep/.eltab {
  width: 1240px;
  margin: 0 auto;
  margin-top: -65px;
  padding-bottom: 184px;
  /deep/.el-tabs__header {
    margin: 0;
    border: none;
    /deep/.el-tabs__nav-wrap {
      /deep/.el-tabs__nav-scroll {
        /deep/.el-tabs__nav {
          border: none;
          display: flex;
          align-items: flex-end;
          /deep/.el-tabs__item {
            box-shadow: none;
            width: 276px;
            height: 89px;
            background: #ff8d3a;
            box-shadow: 0px 0px 16px 2px rgba(43, 81, 149, 0.3);
            border-radius: 32px 32px 0px 0px;
            font-size: 24px;
            font-family: "Euclid Flex Bold", Arial, "PingFang SC", Verdana,
              "\5FAE\8F6F\96C5\9ED1";
            font-weight: 500;
            color: #ffffff;
            line-height: 89px;
            text-align: center;
            margin-right: 25px;
            border-left: none;
          }
          /deep/.is-active {
            height: 107px;
            line-height: 127px;
            background: #ffffff;
            color: #333333;
            box-shadow: 0px 0px 16px 2px rgba(0, 0, 0, 0.1);
          }
        }
      }
    }
  }
  /deep/.el-tabs__content {
    width: 1240px;
    min-height: 690px;
    background: #ffffff;
    box-shadow: 0px 10px 10px 0px rgba(0, 0, 0, 0.1);
    border-radius: 0px 0px 48px 48px;
  }
  .tabpane_container {
    padding: 60px 32px 0 29px;
  }
  .secretary_title {
    height: 84px;
    line-height: 84px;
    background: #ffffff;
    box-shadow: 0px 0px 20px 0px rgba(0, 0, 0, 0.05);
    margin-top: 32px;
    margin-bottom: 26px;
    display: flex;
    flex-direction: row;
    align-items: center;
    padding-left: 64px;
    box-sizing: border-box;
    cursor: default;
    .secretary_title_item {
      height: 20px;
      font-size: 14px;

      font-weight: 400;
      color: #333333;
      line-height: 20px;
      margin-right: 24px;
      &:first-child {
        margin-right: 48px;
      }
      &:hover {
        color: #0091ff;
        cursor: pointer;
      }
    }
    .secretary_title_item_active {
      color: #0091ff;
    }
  }
  .secretary_list {
    width: 100%;
    padding-left: 29px;
    padding-right: 30px;
    margin-top: 32px;
    box-sizing: border-box;
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    padding-bottom: 252px;
    &::after {
      content: "";
      flex-grow: 999999;
    }
    .memberlistitem {
      margin-top: 32px;
      flex: 16.6%;
    }
  }
}
</style>


// WEBPACK FOOTER //
// CmsCate.vue?9a4358f2